import React from 'react';

const About = () => {
  return (
  <div 
    name="about" 
    className='w-full min-h-screen bg-gradient-to-b from-slate-800  to-black text-white'
  >
    {/* Primary container */}
    <div 
      className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'
    >
      {/* Heading */}
      <div className='py-4 mt-10'>
        <p className='text-4xl font-bold inline border-b-4 border-orange-600'>
          About
        </p>
      </div>

      {/* Description */}
      <p className='mt-4 text-justify'>
        I'm a Computer Science graduate from the University of Manitoba (Class of 2022) with a background that sits at the intersection of software development, technical leadership, and education. Originally from Dhaka, Bangladesh, I've built my career in Winnipeg, Manitoba — and my path to where I am today has been anything but conventional. 
      </p>
      
      <p className='mt-4 text-justify'>
        On the development side, my hands-on experience includes building and maintaining software at Tista Surveyors — a land surveying firm based in Dhaka — where I worked first as an intern and later as a remote developer. I redesigned their client-facing website using React.js, HTML, and Tailwind CSS, built internal tools that supported daily operations, and took ownership of debugging, testing, and documentation. It was lean, real-world work with no hand-holding, and it gave me exposure to the full software development lifecycle in a way that coursework alone never could have.
      </p>

      <p className='mt-4 text-justify'>
        In parallel, I spent three years tutoring Computer Science and Mathematics remotely through Paper Education, working with students across multiple grade levels simultaneously. Teaching is one of the most effective ways to deepen your own understanding — explaining recursion or algorithm complexity to a struggling student forces a kind of clarity that no amount of solo studying can replicate.
      </p>

      <p className='mt-4 text-justify'>
        My current role as a Technical Team Manager at IntouchCX has pushed me in a different direction entirely. I lead a team of around 20 agents, which has meant developing real skills in performance coaching, conflict resolution, process documentation, and stakeholder communication. It's a demanding environment — high volume, high accountability — and navigating it has made me a sharper communicator and a more patient, deliberate problem-solver than I was when I graduated.
      </p>

      <p className='mt-4 text-justify'>
        Outside of work, I care deeply about my family — my mother is back in Dhaka, and supporting her is a meaningful part of why I work as hard as I do. That sense of purpose doesn't stay at the door when I open my laptop. It's in the work.
      </p>
    </div>
  </div>
  );

  // I am someone who loves mathematics, and have been a math and science tutor throughout my highschool and university life. When I took my first programming class at university, I instantly fell in love with programming, since a lot of programming is essentially applied mathematics.
  
};

export default About;
